import { _ } from "../core/polyglot/polyglot.js";

export const companyAdminRoleName = "CompanyAdminRole";

export const companyImportRoleName = "CompanyImportRole";

export const companyNormalRoleName = "CompanyNormalRole";

export const companyLimitedRoleName = "CompanyLimitedRole";

export const companyDocumentArchiveRoleName = "CompanyDocumentArchiveRole";

/**
 * Todo: Add JSDoc comment
 */
export function allCompanyRoles() {
	return [
		companyAdminRoleName,
		companyImportRoleName,
		companyNormalRoleName,
		companyLimitedRoleName,
		companyDocumentArchiveRoleName,
	];
}

/**
 * Todo: Add JSDoc comment
 */
export function getPresentationName(role) {
	switch (role) {
		case companyAdminRoleName: {
			return _("Administrator");
		}
		case companyImportRoleName: {
			return _("Normal user with import");
		}
		case companyNormalRoleName: {
			return _("Normal user");
		}
		case companyLimitedRoleName: {
			return _("Limited user");
		}
		case companyDocumentArchiveRoleName: {
			return _("Document archive user");
		}
		default: {
			return _("n/a");
		}
	}
}
